import "./index.scss";
import React, { useState } from "react";
import ping from "../../assets/images/icons/ping.svg";
import MiniModal from "../modals/mini-modal";

const Matriz = ({ cml, gee }) => {
  const [hoveredCell, setHoveredCell] = useState(null);

  const getRowIndexFromCML = () => {
    if (cml <= 0) return 2;
    if (cml <= 30) return 0;
    if (cml <= 70) return 1;
    return 2;
  };

  const getColIndexFromGEE = () => {
    if (gee <= 0.5) return 0;
    if (gee <= 1.0) return 1;
    if (gee <= 2.0) return 2;
    return 3;
  };

  const selectedRowIndex = getRowIndexFromCML();
  const selectedColIndex = getColIndexFromGEE();

  const linhaLabels = [
    "CML ≤ 30% <br /> (baixo)",
    "30% < CML ≤ 70% <br /> (moderado)",
    "CML > 70% <br /> (alto)",
  ];

  const colunaLabels = [
    "GEE ≤ 0,5 <br /> (baixo)",
    "0,5 < GEE ≤ 1,0 <br /> (moderado)",
    "1,0 < GEE ≤ 2,0 <br /> (alto)",
    "GEE > 2,0 <br /> (crítico)",
  ];

  const riskDescriptions = [
    [
      {
        text: "Dívida pequena, parcelas bem acomodadas dentro do lucro. Situação saudável e sustentável.",
        variant: "green",
      },
      {
        text: "Dívida crescente, mas ainda suportada pelo lucro. Requer atenção à evolução.",
        variant: "yellow",
      },
      {
        text: "Endividamento alto, mesmo com parcelas suportáveis. Risco de longo prazo.",
        variant: "orange",
      },
      {
        text: "Dívida crítica, mesmo com parcelas aparentemente baixas. Volume total compromete o pagamento.",
        variant: "red",
      },
    ],
    [
      {
        text: "Dívida baixa, mas parcelas já consomem parte relevante do lucro. Cuidado com novas dívidas..",
        variant: "yellow",
      },
      {
        text: "Dívida moderada, mas comprometimento do lucro é alto. Risco de descapitalização.",
        variant: "orange",
      },
      {
        text: "Endividamento alto, parcelas pesadas. Probabilidade elevada de inadimplência.",
        variant: "red",
      },
      {
        text: "Dívida crítica, sem capacidade real de pagamento.",
        variant: "red",
      },
    ],
    [
      {
        text: "Dívida baixa no volume total, mas parcelas muito altas em relação ao lucro. Risco imediato no caixa.",
        variant: "orange",
      },
      {
        text: "Dívida moderada, mas impossível de sustentar. Renegociação urgente necessária.",
        variant: "red",
      },
      {
        text: "Situação crítica. Lucro não cobre as parcelas. Risco de insolvência.",
        variant: "red",
      },
      {
        text: "Insolvência iminente. Dependência de capital externo ou renegociação imediata.",
        variant: "red",
      },
    ],
  ];

  const riskMatrixColors = [
    ["#E8F3D8", "#FEC", "#FCDECF", "#F3D8DA"],
    ["#FEC", "#FCDECF", "#F3D8DA", "#F0A8AF"],
    ["#FCDECF", "#F3D8DA", "#F0A8AF", "#E06C76"],
  ];

  return (
    <div className="matriz-container">
      <div className="matriz-grid">
        <div className="top-label">
          <p className="top-label-text">
            Comprometimento Mensal do Lucro <span>(CML) alcançada</span>
          </p>
        </div>
        <div className="top-empty"></div>
        <div className="top-empty"></div>
        <div className="top-empty"></div>
        <div className="top-empty"></div>

        {riskMatrixColors.map((rowColors, rowPosition) => (
          <React.Fragment key={rowPosition}>
            <div
              className="linha-label"
              dangerouslySetInnerHTML={{ __html: linhaLabels[rowPosition] }}
            ></div>

            {rowColors.map((cellColor, colPosition) => {
              const isSelectedCell =
                rowPosition === selectedRowIndex &&
                colPosition === selectedColIndex;

              return (
                <div
                  key={`${rowPosition}-${colPosition}`}
                  className={`celula ${isSelectedCell ? "ativo" : ""}`}
                  style={{ backgroundColor: cellColor }}
                  onMouseEnter={() =>
                    setHoveredCell({ row: rowPosition, col: colPosition })
                  }
                  onMouseLeave={() => setHoveredCell(null)}
                >
                  {isSelectedCell && (
                    <span className="pin">
                      <img src={ping} alt="Posição atual" />
                    </span>
                  )}

                  {hoveredCell?.row === rowPosition &&
                    hoveredCell?.col === colPosition && (
                      <MiniModal
                        text={riskDescriptions[rowPosition][colPosition].text}
                        variant={
                          riskDescriptions[rowPosition][colPosition].variant
                        }
                        position={colPosition === 3 ? "left" : "center"}
                      />
                    )}
                </div>
              );
            })}
          </React.Fragment>
        ))}

        <div className="vazio">
          <p>
            Grau de Endividamento Econômico <span>(GEE)</span>
          </p>
        </div>
        {colunaLabels.map((label, index) => (
          <div
            key={index}
            className="coluna-label"
            dangerouslySetInnerHTML={{ __html: label }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Matriz;
